import { Box, Flex, Skeleton, Stack } from '@chakra-ui/react';

import { BleedBackground } from '../layouts';

export function ProductPromoSkeleton() {
  return (
    <Flex flexDirection="column" position="relative" pt="5" pb="8">
      <BleedBackground
        bgColor="#00A0E8"
        bgImage="url('/images/tile-promo.png')"
        bgSize="120px"
      />
      <Stack
        direction="row"
        spacing="4"
        alignSelf="flex-end"
        mt="calc((var(--chakra-space-5) + (var(--chakra-sizes-10) / 2)) * -1)"
        mb="3"
        right="0"
        display={{ base: 'none', lg: 'flex' }}
      >
        <Skeleton height="10" width="10" borderRadius="md" />
        <Skeleton height="10" width="10" borderRadius="md" />
      </Stack>
      {/* Products Container */}
      <Flex
        flexDirection="column"
        overflowX={{ base: 'scroll', lg: 'hidden' }}
        css={{
          '&::-webkit-scrollbar': { display: 'none' },
          scrollbarWidth: 'none',
        }}
      >
        <Flex
          h={{ base: '416.5px', md: '475.5px' }}
          ml={{ base: '-4', lg: '-2' }}
          gap={{ base: '4', md: '2' }}
        >
          {/* Promo Card */}
          <Box
            h="full"
            pl={{ base: '4', lg: '2' }}
            flex={{
              base: '0 0 calc((var(--card-width-carousel) + var(--chakra-space-4)) * 1.2)',
              lg: '0 0 33.333%',
            }}
          >
            <Box
              bg="white"
              borderRadius="lg"
              overflow="hidden"
              height="100%"
              p="6"
            >
              <Skeleton
                data-testid="promo-skeleton-header"
                height={{ base: '8', md: '12' }}
                startColor="red.500"
                endColor="red.600"
                borderRadius="md"
                mb="4"
              />
              {/* Promo Content */}
              <Box>
                <Skeleton height="180px" width="100%" />
                <Stack spacing="4" mt="3">
                  <Skeleton height="6" width="80%" />
                  <Skeleton height="3" width="60%" />
                  <Skeleton height="3" width="90%" />
                  <Skeleton height="3" width="90%" />
                  <Skeleton height="3" width="60%" />
                </Stack>
              </Box>
            </Box>
          </Box>
          {/* Product Cards */}
          {[...Array(4)].map((_, i) => (
            <Box
              h="full"
              key={i}
              width={{ md: 'calc(25% - 12px)' }}
              bg="white"
              data-testid="product-card-skeleton"
              p="4"
              borderRadius="lg"
            >
              <Flex
                direction="column"
                gap={{ base: '4', md: '2' }}
                width={{ base: '220px', md: 'unset' }}
              >
                {/* Diskon Label */}
                <Box position="relative">
                  <Skeleton
                    data-testid="product-skeleton-image"
                    height={{ base: '200px', md: '245px' }}
                    width="100%"
                    borderRadius="lg"
                  />
                  <Stack position="absolute" bottom="2" left="2" spacing="2">
                    <Skeleton
                      width="16"
                      height="6"
                      startColor="gray.400"
                      endColor="gray.500"
                      borderRadius="md"
                    />
                    <Skeleton
                      width="16"
                      height="6"
                      startColor="red.500"
                      endColor="red.600"
                      borderRadius="md"
                    />
                  </Stack>
                </Box>
                {/* Product Info */}
                <Stack spacing="3" mt="3">
                  <Skeleton height="4" width="40%" />
                  <Skeleton height="5" width="100%" />
                  <Flex align="center" gap="2">
                    <Skeleton height="6" width="40%" />
                  </Flex>
                  <Skeleton height="2" width="12" />
                  <Skeleton height="2" width="60%" />
                </Stack>
              </Flex>
            </Box>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
}
